import { FieldValues, Path, UseFormRegister } from "react-hook-form";
import { masterType } from "../../../configs/config";
import { InputWrapper, SelectInput } from "../../../pages/onboarding/AboutYouConnectWith.page";
import { Row } from "../../../styles/Utils";

interface MasterTypeInputProps<T extends FieldValues> {
  register: UseFormRegister<T>; // Register function from RHF
  name: Path<T>; // The field name should be a key from the form data type
  disabled?: boolean;
  who: string;
}

export function MasterTypeInput<T extends FieldValues>({ who, register, name }: MasterTypeInputProps<T>) {
  return (
    <InputWrapper>
      <Row $justifyContent="space-between">
        <span>{who}:</span>
        <SelectInput {...register(name, { required: true })}>
          <option value="">--</option>
          {masterType.map((e) => (
            <option value={e} key={e}>
              {e}
            </option>
          ))}
        </SelectInput>
      </Row>
    </InputWrapper>
  );
}
